module.exports = __webpack_public_path__ + "static/media/danamon.56d62206.svg";